import React from 'react';
import Header from '../components/Header';
import Button from '../components/Button';
import { format, parse } from 'date-fns'
import { ArchieveData, FilterArchive } from '../models/card';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    DatePicker
} from '@material-ui/pickers';
import { Link } from "react-router-dom";
import MaskedInput from 'react-text-mask';
import { CircularProgress } from '@material-ui/core';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import DropdownInput from '../components/DropdownInput';

interface ArchieveProps {
    theme?: string;
    className?: string;
    link?: string;
    match?: any;
    firebase?: any;
    history?: any;
}

interface ArchieveState {
    archieve: ArchieveData;
    isLoading: boolean;
    subscription: any;
    filter: FilterArchive;
    isHide: boolean;
    noOfTweets: string;
    isError: boolean;
}

class Archieve extends React.PureComponent<ArchieveProps, ArchieveState> {
    fireBaseUpdateSubscription: any;
    constructor(props: any) {
        super(props);
        this.setFilter = this.setFilter.bind(this);
        this.state = { isLoading: false, archieve: new ArchieveData(),isError: false, noOfTweets: '', isHide: false, subscription: null, filter: new FilterArchive() };
    }
    componentDidMount() {
        const newArchieve = { ...this.state.archieve };
        newArchieve.date = format(new Date(), 'dd/MM/yyyy');
        this.setState({ archieve: newArchieve });
    }

    componentWillUnmount() {
        this.fireBaseUpdateSubscription && this.fireBaseUpdateSubscription();
    }

    handleDateChange = (date: any) => {
        const dateFormat = format(date, 'dd/MM/yyyy');
        const newArchieve = { ...this.state.archieve };
        newArchieve.date = dateFormat;
        this.setState({ archieve: newArchieve });
    }

    setFilter(updatedFilter: FilterArchive, type: string) {
        const filter: FilterArchive = { ...this.state.filter };
        if (type === 'categories') {
            filter.categories = updatedFilter.categories;
        }
        this.setState({ filter: filter });
    }

    setFormArchieve = (e: any, type: string) => {
        const newArchieve = { ...this.state.archieve };
        switch (type) {
            case 'name':
                newArchieve.name = e.target.value.trim();
                this.setState({ archieve: newArchieve, isError: false });
                break;
            case 'noOfTweets':
                const value = e.target.value;
                newArchieve.noOfTweets = value;
                this.setState({ archieve: newArchieve });
                break;
            case 'description':
                newArchieve.description = e.target.value;
                this.setState({ archieve: newArchieve });
                break;
            default:
                break;
        }
    }

    onCreateArchieve = () => {
        if(this.state.archieve.name.trim() !== ''){
            const query =  this.props.firebase.database().ref('archieve').orderByKey().limitToLast(1);
            query.once('value', (snapshot: any) => {
                    let key = Number(Object.keys(snapshot.val())[0]);
                    let newKey = key + 1;
                    const { archieve, isHide, filter } = this.state;
                    const newArchieve = {...archieve};
                    newArchieve.id = newKey;
                    newArchieve.name = '#' + archieve.name;
                    newArchieve.noOfTweets = Number(archieve.noOfTweets);
                    newArchieve.categories = filter.categories ?  filter.categories.map((data:any) => data.value) : []; 
                    if (isHide) {
                        newArchieve.isShow = false;
                    }
                    this.props.firebase.database().ref('archieve/' + newKey).set(newArchieve).then(()=>{
                        this.props.history.push('/');
                    });
                });
        } else {
            this.setState({isError: true });
        }
    }

    addCondition = (e:any) => {
        e.preventDefault();
        const { isHide } = this.state;
        this.setState({ isHide: !isHide });
    }

    render() {
        const { archieve, isLoading, filter, isError } = this.state;
        const { className } = this.props;
        if (isLoading) {
            return (
                <React.Fragment>
                    <Header className={'m-0'} />
                    <div className='container-center' style={{ margin: '40px' }}>
                        <CircularProgress color={"primary"} style={{ color: '#fcd745' }} size={120} thickness={2.0} />
                    </div>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <Header className={'m-0'} />
                <div className={`${className ? className : ''}`} >
                    <div className="card-archieve" style={{ width: '100%', maxHeight: '800px', height: '100%', cursor: 'auto' }}>
                        <div className="row">
                            <div className="col-6">
                                <div className="sub-title" style={{ float: 'left', fontSize: '24px' }}>
                                    Date
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            disableToolbar
                                            variant="dialog"
                                            margin="normal"
                                            format="dd/MM/yyyy"
                                            id="date-picker-start"
                                            emptyLabel={''}
                                            style={{ width: '120px', marginLeft: '20px' }}
                                            minDate={'02/07/2020'}
                                            maxDate={'28/02/2021'}
                                            value={parse(archieve.date, 'dd/MM/yyyy', new Date())}
                                            onChange={(e: MaterialUiPickersDate) => { this.handleDateChange(e) }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="sub-title">
                                    <Link to="/">
                                        <CloseOutlinedIcon className={`close-outline`} />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-end', overflow: 'hidden' }}>
                            <div style={{ flexGrow: 2, paddingRight: '20px' }}>
                                <div className={`${isError ? 'text-error': ''} title`} style={{ display: 'flex', flexWrap: 'nowrap', width: '100%', fontSize: '40px' }} >
                                    <span>#</span> <input value={archieve.name}  className={`${isError ? 'text-error-input': ''}`} style={{ border: '0', width: '100%', color: '#707070', borderBottom: '1px solid #707070' }} maxLength={25} onChange={(e) => { this.setFormArchieve(e, 'name') }} />
                                </div>
                            </div>
                            <div style={{ flexGrow: 1, paddingLeft: '40px', fontSize: '25px' }}>
                                <MaskedInput
                                    mask={[/\d/, /\d/, /\d/, /\d/,/\d/, /\d/, /\d/, /\d/]}
                                    className="input-archieve"
                                    guide={false}
                                    defaultValue={archieve.noOfTweets}
                                    id="my-input-id"
                                    style={{width: '100%'}}
                                    onBlur={(e)=>{this.setFormArchieve(e, 'noOfTweets')}}
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontSize: '20px' }}>
                                <div style={{ marginTop: '30px' }}><DropdownInput className="width-150" setFilter={this.setFilter} filter={filter} /></div>
                            </div>
                            <div>
                                <div className="text-right">
                                    <p style={{ marginBottom: '5px' }}>Volume (Tweets)</p>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div style={{ overflow: 'scroll' }}>
                            <div style={{ wordBreak: 'break-all' }}>
                                <textarea onChange={(e) => { this.setFormArchieve(e, 'description') }} style={{ width: '100%', fontWeight: 100, color: 'inherit' }} maxLength={800} value={archieve.description} rows={3}></textarea>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-10">
                                Description
                            </div>
                            <div className="col-2">
                                <div className="mt-20" style={{ cursor: 'pointer' }}>
                                    <Button text={'+Submit'} onClickBtn={() => {this.onCreateArchieve()}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ marginTop: '20px', padding: '0 20px' }}>
                        <label style={{ display: 'flex', alignItems: 'center' }} onClick={(e) => { this.addCondition(e) }}>
                            <input type="checkbox" checked={this.state.isHide} style={{ transform: 'scale(1.5)', marginRight: '20px' }}/>
                            <div>
                                ข้อมูลที่เขียนอาจส่งผลต่อความปลอดภัยของเว็บไซต์ และกองบรรณาธิการ ผู้เขียนจึงเลือกที่จะเปิดเผยและปกปิดข้อมูลบางส่วนที่มีประโยชน์พอให้อ่าน และไม่เสี่ยงพอจะทำให้เกิดอันตราย
                            </div>
                        </label>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Archieve;